const clearCacheData = () => {
	window.caches &&
		window.caches.keys &&
		window.caches.keys().then(names => {
			names.forEach(name => {
				caches.delete(name)
			})
		})
}

export default clearCacheData
